import { createContext, useContext } from 'react';

export type ColorTheme = 'dark' | 'light';

export const ThemeContext = createContext<ColorTheme>('dark');

export function useColorTheme(): ColorTheme {
  return useContext(ThemeContext);
}
